import { render, staticRenderFns } from "./DealListItem.vue?vue&type=template&id=42f648f0&scoped=true&"
import script from "./DealListItem.vue?vue&type=script&lang=js&"
export * from "./DealListItem.vue?vue&type=script&lang=js&"
import style0 from "./DealListItem.vue?vue&type=style&index=0&id=42f648f0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42f648f0",
  null
  
)

component.options.__file = "DealListItem.vue"
export default component.exports